import type { IconData } from '@stacksjs/iconify-core'

export const save: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m472.971 122.344l-99.315-99.315A23.84 23.84 0 0 0 356.687 16H56a24.03 24.03 0 0 0-24 24v432a24.03 24.03 0 0 0 24 24h400a24.03 24.03 0 0 0 24-24V139.313a23.84 23.84 0 0 0-7.029-16.969M320 48v96H176V48Zm128 416H64V48h80v128h208V48h1.373L448 142.627Z\"/><path fill=\"currentColor\" d=\"M252 224a92 92 0 1 0 92 92a92.1 92.1 0 0 0-92-92m0 152a60 60 0 1 1 60-60a60.07 60.07 0 0 1-60 60\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default save
